module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hellowd_channel_content"
  }, [_c('section', [_c('el-container', {
    staticStyle: {
      "height": "550px",
      "background-color": "#f6f6f6"
    }
  }, [_c('el-aside', {
    staticStyle: {
      "background-color": "#fff"
    },
    attrs: {
      "width": "200px"
    }
  }, [_c('el-menu', {
    attrs: {
      "default-openeds": ['1', '3']
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "2"
    }
  }, [_c('i', {
    staticClass: "fa fa-sliders"
  }), _vm._v(" "), _c('span', {
    staticClass: "isactive dslabel",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("选择渠道")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-aa"
  }), _vm._v(" "), _c('span', {
    staticClass: "dslabel",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("广告组")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-aa"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("推广目的")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-tags"
  }), _vm._v(" "), _c('span', {
    staticClass: "dslabel",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("广告计划")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-aa"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("用户定向")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-aa"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("设置预算")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-aa"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("计划名称")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "4",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-setting"
  }), _vm._v(" "), _c('span', {
    staticClass: "dslabel",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("广告创意")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-aa"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("制作创意")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-aa"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("投放位置")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-aa"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("创意分类")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-aa"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("创意名称")])])], 1)], 1), _vm._v(" "), _c('el-container', [_c('el-main', [_c('el-page-header', {
    attrs: {
      "content": "选择渠道"
    },
    on: {
      "back": _vm.goBack
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "channel_list",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content c1 channel_active"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content c2"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content c3"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content other"
  }, [_vm._v("更多其他渠道 >> ")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "hellowd_ca_btn"
  }, [_c('router-link', {
    attrs: {
      "to": "/promotion/110659871557"
    }
  }, [_vm._v("立即前往 "), _c('i', {
    staticClass: "fa fa-long-arrow-right"
  })])], 1)])], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e901417"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/adv/channel.vue
// module id = 1102
// module chunks = 38